import { useEffect } from 'react';

import { RELOAD_STATE } from '../common/actions';

const useReloadState = (settings, dispatch, wizardSaved, setWizardSaved) => {
    useEffect(() => {
        if (wizardSaved) {
            dispatch({ type: RELOAD_STATE, payload: { settings } });
            setWizardSaved(false);
        }
    }, [settings, dispatch, wizardSaved, setWizardSaved]);
};

export default useReloadState;
